import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { NumberFormatter } from "app/common/utils/number-formatter";
import { Progress } from "app/pages/digital-marketing/common/ui/Progress/Progress";

import { MetricsLegendItem, MetricsLegendList } from "./styled";
import type { IMetricsProgressProps } from "./types";

export const MetricsProgress = ({ main, other, height = 12 }: IMetricsProgressProps) => {
    const mainColor = colorsPalettes.blue["400"];
    const otherColor = colorsPalettes.sky["300"];

    const mainValue = main.value ?? 0;
    const otherValue = other.value ?? 0;

    return (
        <Stack gap="8px">
            <MetricsLegendList>
                <MetricsLegendItem
                    dotColor={mainColor}
                    value={NumberFormatter.toPercent(main.value, 0, "—")}
                >
                    {main.label}
                </MetricsLegendItem>
                <MetricsLegendItem
                    dotColor={otherColor}
                    value={NumberFormatter.toPercent(other.value, 0, "—")}
                >
                    {other.label}
                </MetricsLegendItem>
            </MetricsLegendList>
            <Progress
                height={height}
                backgroundColor={otherColor}
            >
                <Progress.Value
                    value={mainValue}
                    color={mainColor}
                    withBorder
                />
                <Progress.Value
                    value={otherValue}
                    color={otherColor}
                />
            </Progress>
        </Stack>
    );
};
